import { createSelector } from '@ngrx/store';
import { selectExperiencesState } from '../reducers';
import * as fromCxExperience from '../reducers/cx-experience.reducer';

export const selectCxExperiences = createSelector(selectExperiencesState, fromCxExperience.selectAll);
export const selectCxExperienceIds = createSelector(selectExperiencesState, fromCxExperience.selectIds);
export const selectCxExperienceEntities = createSelector(selectExperiencesState, fromCxExperience.selectEntities);
export const selectCxExperienceTotal = createSelector(selectExperiencesState, fromCxExperience.selectTotal);
export const selectCxExperienceById = () =>
  createSelector(selectCxExperienceEntities, (cxExperienceEntities, { id }) => cxExperienceEntities[id]);
export const selectCxExperiencesById = () =>
  createSelector(
    selectCxExperienceEntities,
    (cxExperienceEntities, { ids }) =>
      ids.map((id) => cxExperienceEntities[id]).filter(Boolean) as fromCxExperience.CxExperienceEntity[],
  );
export const selectActiveCxExperienceId = createSelector(selectExperiencesState, fromCxExperience.selectActiveEntityId);

export const selectActiveCxExperience = createSelector(
  selectCxExperienceEntities,
  selectActiveCxExperienceId,
  (cxExperienceEntities, id) => id && cxExperienceEntities[id],
);

export const selectCustomerExperiencesFiltered = createSelector(
  selectExperiencesState,
  fromCxExperience.selectCustomerExperiencesFiltered,
);

export const jobsiteExperiencesFiltered = createSelector(
  selectExperiencesState,
  (state: fromCxExperience.CxExperienceState) => state?.entities,
);
